const namespaced = true

const state = {
  isUploadError: false,
  // 3 types of status : upload, uploading, uploaded
  status: 'upload',
  progress: 0,
  fileName: null,
  fileSize: 0
}

const getters = {
  isUploadError: state => state.isUploadError,
  status: state => state.status,
  progress: state => state.progress,
  fileName: state => state.fileName,
  fileSize: state => state.fileSize
}

const mutations = {
  SET_IS_UPLOAD_ERROR: (state, payload) => {
    state.isUploadError = payload
  },
  SET_STATUS: (state, payload) => {
    state.status = payload
  },
  SET_PROGRESS: (state, payload) => {
    state.progress = payload
  },
  SET_FILE_NAME: (state, payload) => {
    state.fileName = payload
  },
  SET_FILE_SIZE: (state, payload) => {
    state.fileSize = payload
  }
}

const actions = {
  reset({ commit }) {
    commit('SET_IS_UPLOAD_ERROR', false)
    commit('SET_STATUS', 'upload')
    commit('SET_PROGRESS', 0)
    commit('SET_FILE_NAME', null)
    commit('SET_FILE_SIZE', 0)
  }
}

export default { namespaced, state, getters, mutations, actions }
